import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'

// کامپوننت‌های مشترک گزارش — هم در صفحات گزارش و هم در مینی‌گزارش‌های
// درون‌ماژولی استفاده می‌شوند، پس یک‌بار سراسری ثبت می‌شوند.
import ReportFilterBar from '@core/components/report/ReportFilterBar.vue'
import TrafficFilterBar from '@core/components/report/TrafficFilterBar.vue'
import ReportVisitLog from '@core/components/report/ReportVisitLog.vue'
import ReportChart from '@core/components/report/ReportChart.vue'
import ReportTable from '@core/components/report/ReportTable.vue'
import ReportFunnel from '@core/components/report/ReportFunnel.vue'
import ReportHeatmap from '@core/components/report/ReportHeatmap.vue'
import KpiCard from '@core/components/report/KpiCard.vue'
import EntityReportPanel from '@core/components/report/EntityReportPanel.vue'

Vue.component(FeatherIcon.name, FeatherIcon)

Vue.component('ReportFilterBar', ReportFilterBar)
Vue.component('TrafficFilterBar', TrafficFilterBar)
Vue.component('ReportVisitLog', ReportVisitLog)
Vue.component('ReportChart', ReportChart)
Vue.component('ReportTable', ReportTable)
Vue.component('ReportFunnel', ReportFunnel)
Vue.component('ReportHeatmap', ReportHeatmap)
Vue.component('KpiCard', KpiCard)
Vue.component('EntityReportPanel', EntityReportPanel)
